import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Icon } from 'antd'

import { policies } from '@services/api'

@inject((store: any) => {
    const { popupStore, policiesStore, rightParamSetStore } = store
    return { popupStore, policiesStore, rightParamSetStore }
})
@observer
export default class Policy extends Component<any, any> {
    state: any = {
        errors: {},
        dettach: false
    }
    udpateRightParamSet = async right_param_set_id => {
        const { policy, policiesStore, rightParamSetStore } = this.props
        await policies.updateRightParamSet({ id: policy.id, right_param_set_id })
        if (!right_param_set_id) this.toggleDettach()
        await policiesStore.setPagination({ page: 1 })
        await rightParamSetStore.getList()
    }
    toggleDettach = () => {
        this.setState(prevState => ({ dettach: !prevState.dettach }))
    }
    render() {
        const { policy, popupStore } = this.props
        let listStyle = {}
        let linkButton
        let linkText
        if (policy['right_param_set_id']) {
            if (policy['right_param_set_id'] === popupStore.info.right_param_set_id) {
                listStyle = { backgroundColor: '#ffefdf' }
                linkButton = (
                    <a onClick={() => this.toggleDettach()} style={{ textDecoration: 'underline' }}>
                        <Icon type="close" />
                        הסר שיוך
                    </a>
                )
                linkText = (
                    <span>
                        <Icon type="check" /> הפוליסה משוייכת לטבלה זו
                    </span>
                )
            } else if (policy['right_param_set_id'] !== popupStore.info.right_param_set_id) {
                listStyle = { backgroundColor: '#ececec', borderBottom: '1px solid #d8d8d8' }
                linkButton = ''
                linkText = (
                    <span>
                        הפוליסה משוייכת לטבלה - {policy['right_param_set_name']}({policy['right_param_set_id']})
                    </span>
                )
            }
        } else {
            listStyle = { backgroundColor: 'white' }
            linkButton = (
                <a
                    onClick={() => this.udpateRightParamSet(popupStore.info.right_param_set_id)}
                    style={{ color: '#e77910', fontWeight: 'bold', textDecoration: 'underline' }}
                >
                    <Icon type="check" />
                    שייך לטבלה
                </a>
            )
            linkText = ''
        }

        return (
            <div style={{ ...listStyle, padding: '0.5rem', flexDirection: 'column', width: '100%' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div style={{ padding: '0 0 0 0.5rem' }}>
                        <a
                            style={{ textDecoration: 'underline' }}
                            target="_blank"
                            href={`/insurance/policy/${policy['id']}`}
                        >
                            {policy['id']}
                        </a>
                        | {policy['name']}
                    </div>
                    <div style={{ whiteSpace: 'nowrap' }}>{linkButton}</div>
                </div>
                <div style={{ width: '100%', fontWeight: 'bold', marginTop: '0.2rem' }}>{linkText}</div>
                {this.state.dettach && (
                    <div
                        style={{
                            backgroundColor: '#8c1515',
                            color: 'white',
                            padding: '0.5rem',
                            textAlign: 'center',
                            margin: '0.5rem 0'
                        }}
                    >
                        <div>
                            <strong style={{ fontSize: '1.1rem' }}>אזהרה!</strong>
                            <div> הסרת שיוך פוליסה לטבלה תסיר את כל הגדרות הזכויות והפרמטרים תחת פוליסה זו</div>
                        </div>
                        <div>
                            <a onClick={() => this.udpateRightParamSet(null)} style={{ textDecoration: 'underline' }}>
                                הסר שיוך לטבלה
                            </a>
                            |
                            <a style={{ textDecoration: 'underline' }} onClick={() => this.toggleDettach()}>
                                ביטול
                            </a>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}
